import { createFrontendModule } from '@backstage/frontend-plugin-api';
import homePlugin from '@backstage/plugin-home/alpha';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';

/** The v2 design's home, in place of the customizable widget grid. */
export const byxHomeLayout = HomePageLayoutBlueprint.make({
  name: 'byx',
  params: {
    loader: () => import('./ByxHomeLayout').then(m => m.ByxHomeLayout),
  },
});

/**
 * The plugin's page hides the page header; the design shows "Início" like
 * every other page, which also centers the home in the shared column.
 */
export const byxHomePage = homePlugin.getExtension('page:home').override({
  params: { noHeader: false },
});

// The layout input only accepts extensions from the home plugin itself.
export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [byxHomeLayout, byxHomePage],
});
